import { formatPercentage } from "../../utils/formatters";
import styles from "./LiveProgressIndicator.module.css";

export interface LiveProgressIndicatorProps {
  status: "pending" | "running";
  matchRate?: number;
}

export function LiveProgressIndicator({
  status,
  matchRate,
}: LiveProgressIndicatorProps) {
  if (status === "pending") {
    return (
      <div
        className={styles.pendingContainer}
        data-testid="live-progress-indicator"
      >
        <span className={styles.pendingDot} />
        <span className={styles.pendingLabel}>Pending</span>
      </div>
    );
  }

  return (
    <div
      className={styles.runningContainer}
      data-testid="live-progress-indicator"
    >
      <div className={styles.progressTrack}>
        <div
          className={styles.progressBar}
          style={{
            width:
              matchRate != null && Number.isFinite(matchRate)
                ? `${Math.max(0, Math.min(matchRate, 100))}%`
                : "100%",
          }}
        />
      </div>
      {matchRate != null && Number.isFinite(matchRate) && (
        <span className={styles.matchLabel}>{formatPercentage(matchRate)}</span>
      )}
    </div>
  );
}
